import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Box, Grid, IconButton, Paper, TextField, Typography } from '@mui/material';
import React from 'react';
import { Member } from '../../Models/Member/Member.model';
import IProviderSelectOption from '../../Models/Provider/ProviderSelectOption.model';
import IRole from '../../Models/Role/Role.model';
import { ITeamRole } from '../../Models/CareTeams/TeamRole.model';
import { ITeamRoleAlternate } from '../../Models/CareTeams/TeamRoleAlternate.model';

interface RoleWithAlternatesProps {
    role: ITeamRole;
    roles: IRole[];
    providerOptions: IProviderSelectOption[];
    assignedMembers: Member[];
    expanded: boolean;
    onExpand: () => void;
    teamRoleAlternates: ITeamRoleAlternate[];
}

const RoleWithAlternates: React.FC<RoleWithAlternatesProps> = ({ role, roles, providerOptions, assignedMembers, expanded, onExpand, teamRoleAlternates }) => {
    const availableProviders = providerOptions.filter((provider) => provider.RoleId === role.RoleId);
    const roleName = roles.find((r) => r.Id === role.RoleId)?.Name;
    const providerName = availableProviders.find((p) => p.ProviderId === role.AssignedProviderId)?.ProviderName;
    const alternates = teamRoleAlternates.filter((alt) => alt.RoleId === role.RoleId);

    return (
        <Grid size={12}>
            <TextField
                label={`Primary Provider for ${roleName}`}
                value={providerName}
                InputProps={{
                    readOnly: true,
                    style: { color: 'black' },
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                fullWidth
            />
            <Box sx={{ display: 'flex', alignItems: 'center', paddingLeft: 2 }}>
                <Typography variant="subtitle1" sx={{ fontSize: '0.825rem' }}>
                    Alternate Provider (for certain members):
                </Typography>
                <IconButton onClick={onExpand}>{expanded ? <ExpandLess /> : <ExpandMore />}</IconButton>
            </Box>
            {expanded && (
                <Paper variant="outlined" sx={{ marginLeft: 2, paddingLeft: 4, padding: 2 }}>
                    {alternates.length > 0 ? (
                        alternates.map((alternate) => {
                            const member = assignedMembers.find((m) => m.Id === alternate.MemberId);
                            const alternateProvider = providerOptions.find((p) => p.ProviderId === alternate.AssignedProviderId);
                            return (
                                <Typography key={alternate.MemberId} variant="subtitle2">
                                    - {member?.FirstName} {member?.LastName} → Alternate Provider: {alternateProvider?.ProviderName}
                                </Typography>
                            );
                        })
                    ) : (
                        <Typography variant="subtitle2">No members currently prefer an alternate for this role.</Typography>
                    )}
                </Paper>
            )}
        </Grid>
    );
};

export default RoleWithAlternates;
